import {
  NotificationToast,
  Spinner,
  Application,
  Card,
  Display,
  Tab,
  MessageBox,
  ICanvasError,
  ErrorDialog,
  Confirm,
  Layout,
  ButtonGroup,
  RecordHeader,
  ColorSwatch,
  Column,
  DataGrid,
  EmptyState,
  FileUpload,
  FilterBox,
  Icon,
  Line,
  NavLink,
  Panel,
  RadioButtons,
  RecordTabs,
  TabSet,
  Timeline,
  Url,
  Screen,
  Spacer,
  Text,
} from "./ktm-ui";
import { KTMApi } from "api/KTMApi";
import { Dialog } from "ktm-ui";
import { Navigator } from "ktm-ui/components/Navigator";
import Signin from "ktm-ui/components/Signin";
import { ISigninProps } from "ktm-ui/core/Application";
import { BrowserRouter, Route } from "react-router-dom";
import { ClipboardPen, Building2, Users, DollarSign, BarChart3, Search, BookOpen, Database } from "lucide-react";
import { Toaster } from "react-hot-toast";
import { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { CustomLoading } from "components/CustomLoading";
import { Button } from "react-bootstrap";
import FloatingHelpButton from "./ktm-ui/components/FloatingHelpButton";

Application.addComponents("UI", {
  Card,
  Display,
  Tab,
  Layout,
  Button,
  DialogHeader: Dialog.Header,
  DialogFooter: Dialog.Footer,
  ButtonGroup,
  RecordHeader,
  ColorSwatch,
  Column,
  DataGrid,
  EmptyState,
  FileUpload,
  FilterBox,
  Icon,
  Line,
  NavLink,
  Panel,
  RadioButtons,
  RecordTabs,
  TabSet,
  Timeline,
  Screen,
  Spacer,
  Text,
});

Application.instance.getMessageBox = () => MessageBox as any;
Application.instance.getConfirmDialog = () => Confirm as any;
Application.instance.doPostRequest = KTMApi.doPostRequest;
Application.instance.renderError = (error: ICanvasError) => (
  <ErrorDialog error={error} />
);
Application.instance.host = "";
Application.instance.renderSignin = (props: ISigninProps) => {
  return (
    <Signin
      app={props.app}
      done={props.done}
      token={props.token}
      settings={props.app.signinSettings}
    />
  );
};

let userVal = null;
function App() {
  const [user, setUser] = useState(false);
  const [hideFinancials, setHideFinancials] = useState(true);
  const [hideReports, setHideReports] = useState(true);
  const [hideDatabase, setHideDatabase] = useState(true);
  const [hideManuals, setHideManuals] = useState(true);
  const [rolesLoaded, setRolesLoaded] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchValidation() {
      try {
        const res = await fetch("/api/PlanAdmin/validateadmin");
        const data = await res.json();
        if (!cancelled) {
          setUser(data.disableAccess);
          setHideFinancials(data.hideFinancials);
          setHideReports(data.hideReports);
          setHideDatabase(data.hideDatabase);
          setHideManuals(data.hideManuals);
          setRolesLoaded(true);
          setLoading(false);
        }
      } catch (err) {
        if (!cancelled) {
          setLoading(false);
          setTimeout(fetchValidation, 1500);
        }
      }
    }

    fetchValidation();
    return () => { cancelled = true; };
  }, []);

  userVal = user;

  const homeStyle = {
      backgroundColor: "#f0f2f4",
      margin: "auto",
      height: "100vh",
  };

  return (
    <div className="App">
      <NotificationToast />
      <Toaster
        position="top-center"
        toastOptions={{
          style: {
            background: "#fff",
            color: "#374151",
            boxShadow: "0 4px 24px rgba(0, 0, 0, 0.15)",
            borderRadius: "12px",
            padding: "12px 16px",
          },
        }}
      />
      <Spinner />
      {loading ? <CustomLoading /> : 
        <div style={homeStyle}>
          <BrowserRouter>
            <Route path="/" render={(routeProps) => <RenderNavigator routeProps={routeProps} hideFinancials={hideFinancials} hideReports={hideReports} hideDatabase={hideDatabase} hideManuals={hideManuals} rolesLoaded={rolesLoaded} />} />
          </BrowserRouter>
          <FloatingHelpButton/> 
        </div>
      }
    </div>
  );
}

function RenderNavigator(props) {
  let location = props.routeProps.location;
  let parsed = Url.parse(location.pathname, location.search);
  const brandInfo = useBrandInfo(location.pathname, location.search);

  let urlPath = location.pathname;
  if (parsed.screen === "undefined") parsed.screen = undefined;

  if (urlPath === "/") window.location.href = "/ops";

  if (props.hideFinancials && parsed.screen === "financials") {
    props.routeProps.history.push("/ops");
    return null;
  }

  if (props.hideReports && parsed.screen === "dashboardreport") {
    props.routeProps.history.push("/ops");
    return null;
  }

  if (props.hideDatabase && parsed.screen === "database") {
    props.routeProps.history.push("/ops");
    return null;
  }

  if (props.hideManuals && parsed.screen === "manuals") {
    props.routeProps.history.push("/ops");
    return null;
  }

  const customLogoStyle = brandInfo.brandLogo !== "/nhclogo.png" ? { padding: "0" } : {};

  let navigatorDisplay = !parsed.screen ? "none" : "block";

  let menu;
  if (urlPath === "/ops" && userVal === false) {
    menu = !props.rolesLoaded ? (
      <CustomLoading />
    ) : (
      <>
        <div className="home-hero">
          <h1 className="home-hero-title">Operations</h1>
          <p className="home-hero-subtitle">Select a section to get started</p>
        </div>
        <div className="home-card-container">
          <div className="home-card-grid">
            <a href="/ops/enroll.policy.browse" className="home-card">
              <div className="home-card-icon-wrapper">
                <ClipboardPen size={22} />
              </div>
              <div className="home-card-title">Enrollment</div>
              <div className="home-card-desc">Add new or manage pending enrollments</div>
            </a>
            <a href="/ops/active.policy.browse" className="home-card">
              <div className="home-card-icon-wrapper">
                <Building2 size={22} />
              </div>
              <div className="home-card-title">Companies</div>
              <div className="home-card-desc">Manage existing companies</div>
            </a>
            <a href="ops/advisors" className="home-card">
              <div className="home-card-icon-wrapper">
                <Users size={22} />
              </div>
              <div className="home-card-title">Advisors</div>
              <div className="home-card-desc">Manage distro accounts and advisors</div>
            </a>
            {!props.hideFinancials && (
              <a href="ops/financials" className="home-card">
                <div className="home-card-icon-wrapper">
                  <DollarSign size={22} />
                </div>
                <div className="home-card-title">Financials</div>
                <div className="home-card-desc">Admin financial operations</div>
              </a>
            )}
            {!props.hideReports && (
              <a href="ops/dashboardreport" className="home-card">
                <div className="home-card-icon-wrapper">
                  <BarChart3 size={22} />
                </div>
                <div className="home-card-title">Reports</div>
                <div className="home-card-desc">General NHC reports</div>
              </a>
            )}
            <a href="ops/search" className="home-card">
              <div className="home-card-icon-wrapper">
                <Search size={22} />
              </div>
              <div className="home-card-title">Search</div>
              <div className="home-card-desc">Company and user search</div>
            </a>
            {!props.hideManuals && (
              <a href="ops/manuals" className="home-card">
                <div className="home-card-icon-wrapper">
                  <BookOpen size={22} />
                </div>
                <div className="home-card-title">Policies & Manuals</div>
                <div className="home-card-desc">Internal knowledge base and documentation</div>
              </a>
            )}
            {!props.hideDatabase && (
              <a href="ops/database" className="home-card">
                <div className="home-card-icon-wrapper">
                  <Database size={24} />
                </div>
                <div className="home-card-title">Database</div>
                <div className="home-card-desc">System database, master lists</div>
              </a>
            )}
          </div>
        </div>
      </>
    );
  } else if (userVal === true) {
    Application.instance.session.signout();
  }

  const mainMenuStyle = { borderRight: "1px solid #e0e0e0", paddingRight: 15 };
  
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div className="nhc-nav-bar" style={{backgroundColor:brandInfo.brandColor}}>
        <div>
          <img className="nav-logo" src={brandInfo.brandLogo} style={customLogoStyle}></img>
        </div>
        <div
          style={{
            alignItems: "flex-end",
            marginRight: 15,
            marginTop: 15,
          }}
        >
          <button
            style={mainMenuStyle}
            onClick={() => {
              props.routeProps.history.push("/ops");
            }}
          >
            Main Menu
          </button>
          <button
            style={{ paddingLeft: 15 }}
            onClick={() => Application.instance.session.signout()}
          >
            Logout
          </button>
        </div>
      </div>
      <div style={{ flexGrow: 1 }}>
        {menu}
        <div key="navigator" style={{ display: navigatorDisplay }}>
          <Navigator
            appName={parsed.app}
            domain={parsed.domain}
            screen={parsed.screen}
            branch={parsed.branch}
            screenProps={parsed.search}
            history={props.routeProps.history}
          />
        </div>
      </div>
    </div>
  );
}

async function fetchAndParseUrl(path, search, resource) {
  let parsed = Url.parse(path, search);
  if (parsed.screen === "undefined") {
    parsed.screen = undefined;
  }
  
  if(parsed.search.policy_id === undefined) return;
  
  const response = await fetch(`/api/Settings/${resource}?policyId=${parsed.search.policy_id}`);
  const res = await response.json();
  if (res.success) {
    return res;
  } else {
    throw new Error('Failed to fetch data');
  }
}

function useBrandInfo(pathname, search) {
  const [brandLogo, setBrandLogo] = useState("/nhclogo.png");
  const [brandColor, setBrandColor] = useState("#fff");
  const [error, setError] = useState(null);

  useEffect(() => {

    async function getBrandLogo() {
      try {
        const res = await fetchAndParseUrl(pathname, search, 'getcompanybrandlogo');
        setBrandLogo("https://nhcfilestorage.blob.core.windows.net/images/"+res.companyBrandLogo);
      } catch (error) {
        setError(error);
      }
    }

    async function getBrandColor() {
      try {
        const res = await fetchAndParseUrl(pathname, search, 'getcompanybrandcolor');
        setBrandColor(res.companyBrandColor);
      } catch (error) {
        setError(error);
      }
    }
  
    getBrandLogo();
    getBrandColor();
  }, [pathname, search]);

  return {brandLogo, brandColor, error};
}

export default App;
